import { db, serverTimestamp } from "../../firebaseClient";
import type { RefRecord } from "../types/legalOps";

const COLLECTION = "legal_refs";

export async function createRef(data: Omit<RefRecord, "id">): Promise<string> {
    const docRef = await db.collection(COLLECTION).add({
        ...data,
        createdAt: serverTimestamp()
    });
    return docRef.id;
}

export async function listRefsByEntity(entityId: string): Promise<RefRecord[]> {
    const snap = await db.collection(COLLECTION)
        .where("linkedEntityIds", "array-contains", entityId)
        .orderBy("createdAt", "desc")
        .get();
    return snap.docs.map(d => ({ id: d.id, ...d.data() } as RefRecord));
}

export async function deleteRef(id: string): Promise<void> {
    await db.collection(COLLECTION).doc(id).delete();
}

export async function updateRef(id: string, patch: Partial<RefRecord>): Promise<void> {
    await db.collection(COLLECTION).doc(id).update(patch);
}
